import { render, staticRenderFns } from "./DriverTrain.vue?vue&type=template&id=155380c4&scoped=true&"
import script from "./DriverTrain.vue?vue&type=script&lang=js&"
export * from "./DriverTrain.vue?vue&type=script&lang=js&"
import style0 from "./DriverTrain.vue?vue&type=style&index=0&id=155380c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155380c4",
  null
  
)

export default component.exports